import { Box, Checkbox, Divider, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ReactNode } from 'react';
import {
  Control,
  Controller,
  FieldPath,
  FieldValues,
  UseFormWatch,
} from 'react-hook-form';

interface BulkFormControlItemProps<T extends FieldValues> {
  /** この項目を一括更新の対象にするかどうかのチェックボックスの項目名 */
  checkName: FieldPath<T>;
  children: ReactNode;
  control: Control<T>;
  /** 選択した求人でデータが混在しているかどうか */
  mixed?: boolean;
  required?: boolean;
  title: string;
  watch: UseFormWatch<T>;
}

/** 一括編集フォームの1項目。更新対象にするかのチェックボックスとデータ混在表示を持つ */
export function BulkFormControlItem<T extends FieldValues>({
  checkName,
  children,
  control,
  mixed,
  required,
  title,
  watch,
}: BulkFormControlItemProps<T>) {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
      width={'40rem'}
      bgcolor={watch(checkName) ? theme.customPalette.selection : undefined}
      pt={2}
    >
      <Box display="flex" gap={2} alignItems="center">
        <Box
          display="flex"
          flexDirection="column"
          width="4rem"
          alignItems="center"
        >
          <Controller
            name={checkName}
            control={control}
            render={({ field }) => (
              <Checkbox {...field} sx={{ height: '3rem', width: '3rem' }} />
            )}
          />
        </Box>
        <Box display="flex" flexDirection="column">
          <Box display="flex" alignItems="center" gap={0.5}>
            <Typography>{title}</Typography>
            {required && (
              <Typography color={theme.customPalette.alert}>*</Typography>
            )}
            {mixed && (
              <Typography ml={2} color={'gray'} fontSize={'0.9rem'}>
                データ混在
              </Typography>
            )}
          </Box>
          {children}
        </Box>
      </Box>
      <Divider />
    </Box>
  );
}
